export default __webpack_public_path__ + "static/media/employer-def.017d96a6.svg";